/* eslint-disable */
import { Timestamp } from "../../../../google/protobuf/timestamp";

export const protobufPackage = "od_protos.sell.seller.data";

/**
 * Data specific to the agent referral offer. This includes both data provided by the seller and
 * by the AgentRefCo service.
 * Next ID: 6
 */
export interface AgentReferralSpecificData {
  availability?:
    | AgentReferralSpecificData_Availability
    | undefined;
  /** Used by operators when accepting an agent referral offer via the admin interface */
  notesForCustomer: string;
  notesForAgent: string;
  referringOperatorId: string;
  /** @deprecated */
  offerFeedbackMarketplaceReferral?: AgentReferralSpecificData_OfferFeedbackMarketplaceReferral | undefined;
}

/** Next ID: 5 */
export interface AgentReferralSpecificData_Availability {
  asap: boolean;
  firstChoice?: AgentReferralSpecificData_Availability_Choice | undefined;
  secondChoice?: AgentReferralSpecificData_Availability_Choice | undefined;
  thirdChoice?: AgentReferralSpecificData_Availability_Choice | undefined;
}

/** Next ID: 3 */
export interface AgentReferralSpecificData_Availability_Choice {
  startTime?: Date | undefined;
  endTime?: Date | undefined;
}

/**
 * Next ID: 4
 *
 * @deprecated
 */
export interface AgentReferralSpecificData_OfferFeedbackMarketplaceReferral {
  /** @deprecated */
  accepted: boolean;
  /** @deprecated */
  callTime?:
    | AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime
    | undefined;
  /** @deprecated */
  declineReason?: AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason | undefined;
}

/**
 * Next ID: 4
 *
 * @deprecated
 */
export interface AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime {
  /** @deprecated */
  startTime?:
    | Date
    | undefined;
  /** @deprecated */
  endTime?:
    | Date
    | undefined;
  /** @deprecated */
  asap: boolean;
}

/**
 * Next ID: 3
 *
 * @deprecated
 */
export interface AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason {
  /** @deprecated */
  reason?:
    | string
    | undefined;
  /** @deprecated */
  other?: string | undefined;
}

function createBaseAgentReferralSpecificData(): AgentReferralSpecificData {
  return {
    availability: undefined,
    notesForCustomer: "",
    notesForAgent: "",
    referringOperatorId: "",
    offerFeedbackMarketplaceReferral: undefined,
  };
}

export const AgentReferralSpecificData = {
  fromJSON(object: any): AgentReferralSpecificData {
    return {
      availability: isSet(object.availability)
        ? AgentReferralSpecificData_Availability.fromJSON(object.availability)
        : undefined,
      notesForCustomer: isSet(object.notesForCustomer) ? String(object.notesForCustomer) : "",
      notesForAgent: isSet(object.notesForAgent) ? String(object.notesForAgent) : "",
      referringOperatorId: isSet(object.referringOperatorId) ? String(object.referringOperatorId) : "",
      offerFeedbackMarketplaceReferral: isSet(object.offerFeedbackMarketplaceReferral)
        ? AgentReferralSpecificData_OfferFeedbackMarketplaceReferral.fromJSON(object.offerFeedbackMarketplaceReferral)
        : undefined,
    };
  },

  toJSON(message: AgentReferralSpecificData): unknown {
    const obj: any = {};
    if (message.availability !== undefined) {
      obj.availability = AgentReferralSpecificData_Availability.toJSON(message.availability);
    }
    if (message.notesForCustomer !== "") {
      obj.notesForCustomer = message.notesForCustomer;
    }
    if (message.notesForAgent !== "") {
      obj.notesForAgent = message.notesForAgent;
    }
    if (message.referringOperatorId !== "") {
      obj.referringOperatorId = message.referringOperatorId;
    }
    if (message.offerFeedbackMarketplaceReferral !== undefined) {
      obj.offerFeedbackMarketplaceReferral = AgentReferralSpecificData_OfferFeedbackMarketplaceReferral.toJSON(
        message.offerFeedbackMarketplaceReferral,
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentReferralSpecificData>, I>>(base?: I): AgentReferralSpecificData {
    return AgentReferralSpecificData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentReferralSpecificData>, I>>(object: I): AgentReferralSpecificData {
    const message = createBaseAgentReferralSpecificData();
    message.availability = (object.availability !== undefined && object.availability !== null)
      ? AgentReferralSpecificData_Availability.fromPartial(object.availability)
      : undefined;
    message.notesForCustomer = object.notesForCustomer ?? "";
    message.notesForAgent = object.notesForAgent ?? "";
    message.referringOperatorId = object.referringOperatorId ?? "";
    message.offerFeedbackMarketplaceReferral =
      (object.offerFeedbackMarketplaceReferral !== undefined && object.offerFeedbackMarketplaceReferral !== null)
        ? AgentReferralSpecificData_OfferFeedbackMarketplaceReferral.fromPartial(
          object.offerFeedbackMarketplaceReferral,
        )
        : undefined;
    return message;
  },
};

function createBaseAgentReferralSpecificData_Availability(): AgentReferralSpecificData_Availability {
  return { asap: false, firstChoice: undefined, secondChoice: undefined, thirdChoice: undefined };
}

export const AgentReferralSpecificData_Availability = {
  fromJSON(object: any): AgentReferralSpecificData_Availability {
    return {
      asap: isSet(object.asap) ? Boolean(object.asap) : false,
      firstChoice: isSet(object.firstChoice)
        ? AgentReferralSpecificData_Availability_Choice.fromJSON(object.firstChoice)
        : undefined,
      secondChoice: isSet(object.secondChoice)
        ? AgentReferralSpecificData_Availability_Choice.fromJSON(object.secondChoice)
        : undefined,
      thirdChoice: isSet(object.thirdChoice)
        ? AgentReferralSpecificData_Availability_Choice.fromJSON(object.thirdChoice)
        : undefined,
    };
  },

  toJSON(message: AgentReferralSpecificData_Availability): unknown {
    const obj: any = {};
    if (message.asap === true) {
      obj.asap = message.asap;
    }
    if (message.firstChoice !== undefined) {
      obj.firstChoice = AgentReferralSpecificData_Availability_Choice.toJSON(message.firstChoice);
    }
    if (message.secondChoice !== undefined) {
      obj.secondChoice = AgentReferralSpecificData_Availability_Choice.toJSON(message.secondChoice);
    }
    if (message.thirdChoice !== undefined) {
      obj.thirdChoice = AgentReferralSpecificData_Availability_Choice.toJSON(message.thirdChoice);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentReferralSpecificData_Availability>, I>>(
    base?: I,
  ): AgentReferralSpecificData_Availability {
    return AgentReferralSpecificData_Availability.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentReferralSpecificData_Availability>, I>>(
    object: I,
  ): AgentReferralSpecificData_Availability {
    const message = createBaseAgentReferralSpecificData_Availability();
    message.asap = object.asap ?? false;
    message.firstChoice = (object.firstChoice !== undefined && object.firstChoice !== null)
      ? AgentReferralSpecificData_Availability_Choice.fromPartial(object.firstChoice)
      : undefined;
    message.secondChoice = (object.secondChoice !== undefined && object.secondChoice !== null)
      ? AgentReferralSpecificData_Availability_Choice.fromPartial(object.secondChoice)
      : undefined;
    message.thirdChoice = (object.thirdChoice !== undefined && object.thirdChoice !== null)
      ? AgentReferralSpecificData_Availability_Choice.fromPartial(object.thirdChoice)
      : undefined;
    return message;
  },
};

function createBaseAgentReferralSpecificData_Availability_Choice(): AgentReferralSpecificData_Availability_Choice {
  return { startTime: undefined, endTime: undefined };
}

export const AgentReferralSpecificData_Availability_Choice = {
  fromJSON(object: any): AgentReferralSpecificData_Availability_Choice {
    return {
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
    };
  },

  toJSON(message: AgentReferralSpecificData_Availability_Choice): unknown {
    const obj: any = {};
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentReferralSpecificData_Availability_Choice>, I>>(
    base?: I,
  ): AgentReferralSpecificData_Availability_Choice {
    return AgentReferralSpecificData_Availability_Choice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentReferralSpecificData_Availability_Choice>, I>>(
    object: I,
  ): AgentReferralSpecificData_Availability_Choice {
    const message = createBaseAgentReferralSpecificData_Availability_Choice();
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    return message;
  },
};

function createBaseAgentReferralSpecificData_OfferFeedbackMarketplaceReferral(): AgentReferralSpecificData_OfferFeedbackMarketplaceReferral {
  return { accepted: false, callTime: undefined, declineReason: undefined };
}

export const AgentReferralSpecificData_OfferFeedbackMarketplaceReferral = {
  fromJSON(object: any): AgentReferralSpecificData_OfferFeedbackMarketplaceReferral {
    return {
      accepted: isSet(object.accepted) ? Boolean(object.accepted) : false,
      callTime: isSet(object.callTime)
        ? AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime.fromJSON(object.callTime)
        : undefined,
      declineReason: isSet(object.declineReason)
        ? AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason.fromJSON(object.declineReason)
        : undefined,
    };
  },

  toJSON(message: AgentReferralSpecificData_OfferFeedbackMarketplaceReferral): unknown {
    const obj: any = {};
    if (message.accepted === true) {
      obj.accepted = message.accepted;
    }
    if (message.callTime !== undefined) {
      obj.callTime = AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime.toJSON(message.callTime);
    }
    if (message.declineReason !== undefined) {
      obj.declineReason = AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason.toJSON(
        message.declineReason,
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentReferralSpecificData_OfferFeedbackMarketplaceReferral>, I>>(
    base?: I,
  ): AgentReferralSpecificData_OfferFeedbackMarketplaceReferral {
    return AgentReferralSpecificData_OfferFeedbackMarketplaceReferral.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentReferralSpecificData_OfferFeedbackMarketplaceReferral>, I>>(
    object: I,
  ): AgentReferralSpecificData_OfferFeedbackMarketplaceReferral {
    const message = createBaseAgentReferralSpecificData_OfferFeedbackMarketplaceReferral();
    message.accepted = object.accepted ?? false;
    message.callTime = (object.callTime !== undefined && object.callTime !== null)
      ? AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime.fromPartial(object.callTime)
      : undefined;
    message.declineReason = (object.declineReason !== undefined && object.declineReason !== null)
      ? AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason.fromPartial(object.declineReason)
      : undefined;
    return message;
  },
};

function createBaseAgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime(): AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime {
  return { startTime: undefined, endTime: undefined, asap: false };
}

export const AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime = {
  fromJSON(object: any): AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime {
    return {
      startTime: isSet(object.startTime) ? fromJsonTimestamp(object.startTime) : undefined,
      endTime: isSet(object.endTime) ? fromJsonTimestamp(object.endTime) : undefined,
      asap: isSet(object.asap) ? Boolean(object.asap) : false,
    };
  },

  toJSON(message: AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime): unknown {
    const obj: any = {};
    if (message.startTime !== undefined) {
      obj.startTime = message.startTime.toISOString();
    }
    if (message.endTime !== undefined) {
      obj.endTime = message.endTime.toISOString();
    }
    if (message.asap === true) {
      obj.asap = message.asap;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime>, I>>(
    base?: I,
  ): AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime {
    return AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime>, I>>(
    object: I,
  ): AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime {
    const message = createBaseAgentReferralSpecificData_OfferFeedbackMarketplaceReferral_CallTime();
    message.startTime = object.startTime ?? undefined;
    message.endTime = object.endTime ?? undefined;
    message.asap = object.asap ?? false;
    return message;
  },
};

function createBaseAgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason(): AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason {
  return { reason: undefined, other: undefined };
}

export const AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason = {
  fromJSON(object: any): AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason {
    return {
      reason: isSet(object.reason) ? String(object.reason) : undefined,
      other: isSet(object.other) ? String(object.other) : undefined,
    };
  },

  toJSON(message: AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason): unknown {
    const obj: any = {};
    if (message.reason !== undefined) {
      obj.reason = message.reason;
    }
    if (message.other !== undefined) {
      obj.other = message.other;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason>, I>>(
    base?: I,
  ): AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason {
    return AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason.fromPartial(base ?? ({} as any));
  },
  fromPartial<
    I extends Exact<DeepPartial<AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason>, I>,
  >(object: I): AgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason {
    const message = createBaseAgentReferralSpecificData_OfferFeedbackMarketplaceReferral_DeclineReason();
    message.reason = object.reason ?? undefined;
    message.other = object.other ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
